/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { WidgetRoleSortOrder } from './WidgetRoleSortOrder';
import {
    WidgetRoleSortOrderFromJSON,
    WidgetRoleSortOrderFromJSONTyped,
    WidgetRoleSortOrderToJSON,
    WidgetRoleSortOrderToJSONTyped,
} from './WidgetRoleSortOrder';
import type { WidgetCategory } from './WidgetCategory';
import {
    WidgetCategoryFromJSON,
    WidgetCategoryFromJSONTyped,
    WidgetCategoryToJSON,
    WidgetCategoryToJSONTyped,
} from './WidgetCategory';

/**
 * 
 * @export
 * @interface UpdateWidgetRequest
 */
export interface UpdateWidgetRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateWidgetRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateWidgetRequest
     */
    displayName: string | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof UpdateWidgetRequest
     */
    sortOrder: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {WidgetCategory}
     * @memberof UpdateWidgetRequest
     */
    category: WidgetCategory;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateWidgetRequest
     */
    widgetRoles: Array<string>;
    /**
     * 
     * @type {Array<WidgetRoleSortOrder>}
     * @memberof UpdateWidgetRequest
     */
    roleOrders?: Array<WidgetRoleSortOrder> | null;
}



/**
 * Check if a given object implements the UpdateWidgetRequest interface.
 */
export function instanceOfUpdateWidgetRequest(value: object): value is UpdateWidgetRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('sortOrder' in value) || value['sortOrder'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('widgetRoles' in value) || value['widgetRoles'] === undefined) return false;
    return true;
}

export function UpdateWidgetRequestFromJSON(json: any): UpdateWidgetRequest {
    return UpdateWidgetRequestFromJSONTyped(json, false);
}

export function UpdateWidgetRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateWidgetRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'displayName': json['displayName'],
        'sortOrder': ActorActivityRecordActorUserIdFromJSON(json['sortOrder']),
        'category': WidgetCategoryFromJSON(json['category']),
        'widgetRoles': json['widgetRoles'],
        'roleOrders': json['roleOrders'] == null ? undefined : ((json['roleOrders'] as Array<any>).map(WidgetRoleSortOrderFromJSON)),
    };
}

export function UpdateWidgetRequestToJSON(json: any): UpdateWidgetRequest {
    return UpdateWidgetRequestToJSONTyped(json, false);
}

export function UpdateWidgetRequestToJSONTyped(value?: UpdateWidgetRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'displayName': value['displayName'],
        'sortOrder': ActorActivityRecordActorUserIdToJSON(value['sortOrder']),
        'category': WidgetCategoryToJSON(value['category']),
        'widgetRoles': value['widgetRoles'],
        'roleOrders': value['roleOrders'] == null ? undefined : ((value['roleOrders'] as Array<any>).map(WidgetRoleSortOrderToJSON)),
    };
}

